import { css } from 'lit';

// import { SHOPS } from '../../constants';

export const sectionStyles = css`

  .welcome-sections {
    display: flex;
    flex-direction: column;
  }

`;

export const tabStyles = css`
sl-tab-group {
  background: white;
}
sl-tab sl-icon {
  padding-right: 5px;  
}
`;

export const searchStyles = css`

  .search-section {
    display: flex;
    flex-direction: column;
    margin: auto;
    align-items: center;
    box-sizing: border-box;
    padding: var(--sl-spacing-x-large);
    background-color: var(--sl-color-primary-700);
    border: 10px solid var(--sl-color-primary-600);
    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.3);
    background-image: url(/img/banner.jpg);
    background-repeat: no-repeat;
    max-width: 600px;
  }

  .search-section.phone {
    border-width: 5px;
    margin: var(--sl-spacing-x-small) auto;
    border-radius: var(--sl-border-radius-small);
  }

  .search-section.laptop {
    margin: var(--sl-spacing-medium) auto;
    border-radius: var(--sl-border-radius-large);
  }

  .search-section.desktop {
    margin: var(--sl-spacing-large) auto;
    border-radius: var(--sl-border-radius-x-large);
  }

  .search-section:hover, .search-section:focus, .search-section:active {
    border-color: var(--sl-color-primary-400);
  }

  .search-section .title {
    color: var(--sl-color-primary-200);
    font-weight: var(--sl-font-weight-bolder);
    font-size: var(--sl-font-size-large);
    font-family: var(--sl-font-mono);
    margin: 0px auto;
    text-transform: uppercase;
  }
`

export const shopStyles = css`
  .shops-section {
    display: flex;
    box-sizing: border-box;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    column-gap: var(--sl-spacing-small);
    margin: var(--sl-spacing-x-small) 0px;
    box-sizing: border-box;
    // padding: var(--sl-spacing-x-small);
    background: white;
  }

  .shops-section .shop {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    column-gap: var(--sl-spacing-small);
    box-sizing: border-box;
    border: 1px solid white;
    border-radius: var(--sl-border-radius-small);
    cursor: pointer;
  }

  .shops-section .shop:hover, .shops-section .shop:focus, .shops-section .shop:active {
    border-color: var(--sl-color-primary-400);
  }

  .shops-section img {
    padding: var(--sl-spacing-3x-small);
  }
  .shops-section promo-donut {
    padding: var(--sl-spacing-3x-small);
  }

  .shops-section.phone img {
    max-width: 40px;
  }

  .shops-section.phone promo-donut {
    max-width: 60px;
  }

  .shops-section.tablet img {
    max-width: 50px;
  }

  .shops-section.tablet promo-donut {
    max-width: 75px;
  }
  .shops-section.laptop img {
    max-width: 60px;
  }

  .shops-section.laptop promo-donut {
    max-width: 95px;
  }
  .shops-section.desktop img {
    max-width: 65px;
  }

  .shops-section.desktop promo-donut {
    max-width: 105px;
  }
`;

// export const productStyles = css`
// .product-slideshow {
//   box-sizing: border-box;
//   position: relative;
//   overflow: hidden;
//   transform: translate3d(0, 0, 0);
// }

// .slideshow-container {
//   display: flex;
//   height: 100%;
//   animation: scrollSlideshow 20s linear infinite;
//   gap: 10px;
// }

// .slideshow-container:hover, .slideshow-container:focus, .slideshow-container:active {
//   animation-play-state: paused;
// }

// product-searchresult {
//   position: relative;
//   flex: 0 0 auto;
// }

// .slideshow-container {
//   animation-duration: 10s;
//   gap: var(--sl-spacing-2x-small);
// }

// .slideshow-container.tablet {
//   animation-duration: 20s;
//   gap: var(--sl-spacing-x-small);
// }

// .slideshow-container.laptop {
//   animation-duration: 35s;
//   gap: var(--sl-spacing-small);
// }

// .slideshow-container.desktop {
//   animation-duration: 50s;
//   gap: var(--sl-spacing-medium);
// }

// .slideshow-container product-searchresult {
//   width: calc(100vw) - 10px;
// }

// .slideshow-container.tablet product-searchresult {
//   width: calc(100vw/3);
// }

// .slideshow-container.laptop product-searchresult {
//   width: calc(100vw/5);
// }

// .slideshow-container.desktop product-searchresult {
//   width: calc(100vw/8);
// }

// @keyframes scrollSlideshow {
//   0% { transform: translateX(0); transform: translateX(100%); }
//   100% { transform: translateX(-100%); }
// }


// `

export const tagsStyles = css`

.tags-section {
  display: flex;
  flex-flow: row wrap;
  box-sizing: border-box;
  justify-content: center;
}

.tags-section.phone {
  gap: var(--sl-spacing-small);
  padding: var(--sl-spacing-2x-small);
}

.tags-section.tablet {
  gap: var(--sl-spacing-medium);
  padding: var(--sl-spacing-x-small);
}

.tags-section.laptop {
  gap: var(--sl-spacing-medium);
  padding: var(--sl-spacing-small);
}

.tags-section.desktop {
  padding: var(--sl-spacing-medium);
  gap: var(--sl-spacing-large);
}

.tag-button {
  display: flex;
  flex-direction: row;
  backdrop-filter: blur(3px);
  border: 1px solid var(--sl-color-primary-100);
  border-radius: var(--sl-border-radius-large);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  transition: transform var(--sl-transition-medium);
  background: var(--sl-color-primary-100);
  color: var(--sl-color-neutral-600);
}  

.tag-button.phone {
  padding: var(--sl-spacing-x-small);
  gap: var(--sl-spacing-small);
  font-size: var(--sl-font-size-x-small);
}  

.tag-button.tablet {
  padding: var(--sl-spacing-small);
  gap: var(--sl-spacing-medium);
  font-size: var(--sl-font-size-small);
}  

.tag-button.laptop {
  padding: var(--sl-spacing-medium);
  gap: var(--sl-spacing-medium);
  font-size: var(--sl-font-size-medium);
}  

.tag-button.desktop {
  padding: var(--sl-spacing-large);
  gap: var(--sl-spacing-large);
  font-size: var(--sl-font-size-large);
}  

.tag-button:hover, .tag-button:focus {
  cursor: pointer;
  color: var(--sl-color-primary-900);
  border-color: var(--sl-color-primary-900);
  transform: scale(1.2);
  z-index: 100;
}

`;